import { render, staticRenderFns } from "./wework.vue?vue&type=template&id=2d358f1e&scoped=true"
import script from "./wework.vue?vue&type=script&lang=js"
export * from "./wework.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d358f1e",
  null
  
)

export default component.exports